import { Col } from "antd";
import { ComponentsCollapse } from "../ComponentsCollapse/ComponentsCollapse";
import { Meet } from "../Meet";
import { VFC } from "react";
import { DocumentReference } from "firebase/firestore";

export const LargeDeviceView: VFC<{
  gameRef: DocumentReference;
  roomId: string;
  setBrowserSupported: (value: boolean) => void;
}> = ({ gameRef, setBrowserSupported, roomId }) => {
  return (
    <>
      <Col md={6} sm={0}>
        <ComponentsCollapse gameRef={gameRef} />
      </Col>
      <Col md={18} sm={24} style={{ width: "100%" }}>
        <Meet
          onChangeSupport={(supported) => {
            setBrowserSupported(supported);
          }}
          roomId={roomId}
        />
      </Col>
    </>
  );
};
